import React from 'react';
import './styles.css';
import { View, Flex } from '@smarterservices/smarter-ui';
import { useEffect, useState } from 'react';
import { usePlayerStore } from '../../../../stores/StoreContext';
import PlayPause from '../PlayPause';
import LiveButton from '../LiveButton';
import JumpBack from '../JumpBack';
import CommentButton from '../Comment';
import FullScreen from '../FullScreen';

const FocusHoverControls = () => {
  const [showControlsOverlay, setShowControlsOverlay] = useState(false);
  const [addAnnotationDialogOpen, setAddAnnotationDialogOpen] = useState(false);

  const showHoverControls = usePlayerStore((state) => state.showHoverControls);

  useEffect(() => {
    if (showHoverControls) {
      setShowControlsOverlay(true);
    } else {
      if (!addAnnotationDialogOpen) {
        setShowControlsOverlay(false);
      }
    }
  }, [showHoverControls]);

  const handleCommentOpen = () => {
    console.log('Comment Open');
    setAddAnnotationDialogOpen(true);
  };

  const handleCommentHide = () => {
    console.log('Comment Hide');
    setAddAnnotationDialogOpen(false);
  };

  return (
    <View
      as="div"
      position="absolute"
      background="primary"
      padding="small none none none"
      withVisualDebug={false}
      className={`video-hover-controls ${showControlsOverlay ? `show` : `hide`}`}
      //className='video-hover-controls show'
      height="60px"
      width="100%"
      themeOverride={{
        backgroundPrimary: 'rgba(255,255,255,0) 100%',
        zIndex: 9000,
      }}
    >
      <Flex as="div" withVisualDebug={false}>
        <Flex.Item as="div" padding="x-small" size="25%" textAlign="end"></Flex.Item>
        <Flex.Item as="div" padding="x-small" shouldShrink shouldGrow textAlign="center">
          <PlayPause />
          <JumpBack />
          {/*
          <CommentButton
            open={addAnnotationDialogOpen}
            onOpen={handleCommentOpen}
            onHide={handleCommentHide}
          />
           */}
          <LiveButton />
          <FullScreen />
        </Flex.Item>
        <Flex.Item as="div" padding="x-small" size="25%" textAlign="start"></Flex.Item>
      </Flex>
    </View>
  );
};

export default FocusHoverControls;
